import { bscTestnet, sepolia, polygonAmoy } from '@reown/appkit/networks'

export const environment = {
    APPKIT_PROJECT_ID: '8d4246b4864adf3c8d6fabc0171b3ab0',
    AOC_TOKEN_CONTRACT: '0x7dD88BF0bcf02C77F80F575A1C202492865137DB',
    AOC_TOKEN_LOCKER: '0x83742182c1bd8BA658576A034b7A82587425fE08',
    BULKMINT_CONTRACT: '0x2b6588a884DD836BF0b91E66741762AA189528be',
    API_BASE_URL: 'https://stagingmultisigapi.alphaomegacoin.com/api/',
    EXPLORER_BASE_URL: 'https://testnet.bscscan.com/tx/', // Backwards compatibility
    // Explorer URLs mapped by network identifier from API (testnet only for dev/staging)
    EXPLORER_URLS: {
      'ETH': 'https://sepolia.etherscan.io/tx/',
      'BSC': 'https://testnet.bscscan.com/tx/',
      'POLYGON': 'https://amoy.polygonscan.com/tx/'
    },
    CONTRIBUTION_BASE_URL: 'https://stagingtokendistributionbackend.alphaomegacoin.com/api/v1/admin/',
    SOCKET_BASE_URL: 'https://stagingmultisigapi.alphaomegacoin.com',
    // Default / primary network for staging
    NETWORK: bscTestnet,
    // Backwards-compatible single RPC (kept in sync with BSCTESTNET)
    RPC_URL : 'https://bnb-testnet.g.alchemy.com/v2/7bN-L9LKOykBAlIcAaw8U',
    // Multi-network support for staging:
    // - BSC Testnet
    // - sepolia (Ethereum testnet)
    SUPPORTED_NETWORKS: [bscTestnet, sepolia, polygonAmoy],
    DEFAULT_NETWORK: bscTestnet,
    RPC_URLS: {
      [bscTestnet.id]: 'https://bnb-testnet.g.alchemy.com/v2/7bN-L9LKOykBAlIcAaw8U',
      // TODO: Replace with your own sepolia RPC endpoint (Infura/Alchemy/etc.)
      [sepolia.id]: 'https://1rpc.io/sepolia',
      [polygonAmoy.id]: 'https://polygon-amoy.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP'
    },
    APP_URL:'https://stagingmultisig.alphaomegacoin.com/'   
    
};
